import { render } from "./image_loader.vue?vue&type=template&id=eabcb338&lang=pug"
import script from "./image_loader.vue?vue&type=script&lang=js"
export * from "./image_loader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__